<template>
  <div v-if="currentMission != null">
    <exo-form hideClose :root="_self" :clear="false">
      <div giveMeATour-v-step="11"></div>
      <template v-slot:titleTooltip>
        <div gt_ParamOrbitTransfert2-v-step="3"></div>
        <exo-help-dialog
          :color="'white--text'"
          :margin="'m-0'"
          v-if="inputs.type === 'Orbital Transfer'"
          title="Orbital Transfer"
        >
          <tooltipParametricOrbitalTransfer />
        </exo-help-dialog>
        <exo-help-dialog
          :color="'white--text'"
          :margin="'m-0'"
          v-if="inputs.type === 'RAAN Phasing'"
          title="RAAN Phasing"
        >
          <tooltipParametricRAANPhasing />
        </exo-help-dialog>
        <exo-help-dialog
          :color="'white--text'"
          :margin="'m-0'"
          v-if="inputs.type === 'Orbit Phasing'"
          title="Orbit Phasing"
        >
          <tooltipParametricOrbitPhasing />
        </exo-help-dialog>
        <exo-help-dialog
          :color="'white--text'"
          :margin="'m-0'"
          v-if="inputs.type === 'LEO Station Keeping'"
          title="LEO Station Keeping"
        >
          <tooltipParametricLEOStationKeeping />
        </exo-help-dialog>
        <exo-help-dialog
          :color="'white--text'"
          :margin="'m-0'"
          v-if="inputs.type === 'Deorbitation'"
          title="Deorbiting"
        >
          <tooltipParametricDeorbitation />
        </exo-help-dialog>
        <exo-help-dialog
          :color="'white--text'"
          :margin="'m-0'"
          v-if="inputs.type === 'Sequence'"
          title="Sequence of maneuvers"
        >
          <tooltipParametricSequenceOfMissions />
        </exo-help-dialog>
        <exo-help-dialog
          :color="'white--text'"
          :margin="'m-0'"
          v-if="inputs.type === 'ADCS Design'"
          title="Attitude Control Design"
        >
          <tooltipParametricADCSDesign />
        </exo-help-dialog>
      </template>
      <exo-input-name
        alignWithParametricField
        :root="_self"
        giveMeATour-v-step="12"
        gt_ParamOrbitTransfert1-v-step="3"
      />
      <exo-input-ref
        :root="_self"
        name="spacecraft"
        type="spacecraft"
        componentRoute="/analyticalspacecraft"
        :disableMultiple="isSequenceType"
        giveMeATour-v-step="13"
        gt_ParamOrbitTransfert1-v-step="4"
        gt_ParamOrbitTransfert2-v-step="4"
      />
      <div
        v-if="this.gt_OrbitTransferParam1.secondSpacecraftTourDone"
        gt_ParamOrbitTransfert1-v-step="19"
      ></div>
      <exo-input-checkbox
        alignWithParametricField
        :root="_self"
        name="enableMassLossAfterSubMissions"
      >
        <tooltipEnableMassLossAfterManeuvers />
      </exo-input-checkbox>
      <exo-input-checkbox
        alignWithParametricField
        :root="_self"
        name="dragPerturbationEnabled"
      >
        <tooltipDragPerturbationEnabled />
      </exo-input-checkbox>
      <exo-form-alert
        v-if="!isAdcsDesignType && inputs.dragPerturbationEnabled"
        type="info"
      >
        WARNING: do not forget to define the drag model in the spacecraft.
      </exo-form-alert>
      <exo-form-alert v-if="isAdcsDesignType" type="info">
        WARNING: do not forget to define the ADCS model in the spacecraft!
      </exo-form-alert>
      <v-col cols="10" v-if="isAdcsDesignType">
        <v-row>
          <v-col cols="4">
            <exo-input-select :root="_self" name="attitudeMode">
              <exo-help-dialog title="Attitude mode">
                The user can choose the attitude mode in which the maneuver is
                executed. There is an impact on attitude through the change of
                spacecraft orientation.
              </exo-help-dialog>
            </exo-input-select>
          </v-col>
          <v-col cols="4">
            <exo-input-checkbox :root="_self" name="fastADCSComputation">
              <exo-help-dialog title="Faster ADCS computation">
                If this option is checked, the torque computation is much faster
                (the computation time is divided by about 50) but less precise.
                It is recommended to check this box for parametric study with a
                lot of parameters and to make one run of the chosen parameter
                with this box unchecked.
              </exo-help-dialog>
            </exo-input-checkbox>
          </v-col>
          <v-col cols="4">
            <exo-input-parametric :root="_self" name="initialLtan" />
          </v-col>
        </v-row>
        <v-row no-gutters justify="start">
          <v-col cols="4">
            <exo-input-double :root="_self" name="tipOffRateX" />
          </v-col>
          <v-col cols="4">
            <exo-input-double :root="_self" name="tipOffRateY" />
          </v-col>
          <v-col cols="4">
            <exo-input-double :root="_self" name="tipOffRateZ">
              <exo-help-dialog title="Tip off rate">
                Tip off rate correspond to the initial angular rate after
                spacecraft separation from launcher. Usually it is the worst
                case for angular rate point of view. This phase is call
                "detumble" and consist in damping the spacecraft angular rate.
                This angular rate depends mainly on center of inertia position
                and inertia matrix. Usually the tip off rate is about 10deg/s
                for cubesat and 1deg/s for small sat.
              </exo-help-dialog>
            </exo-input-double>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start">
          <v-col cols="4">
            <exo-input-double :root="_self" name="solarArrayNormalX" />
          </v-col>
          <v-col cols="4">
            <exo-input-double :root="_self" name="solarArrayNormalY" />
          </v-col>
          <v-col cols="4">
            <exo-input-double :root="_self" name="solarArrayNormalZ">
              <exo-help-dialog title="Solar array normal in spacecraft frame">
                The solar array normal in spacecraft frame corresponds to the
                main direction of the solar panel given in spacecraft frame.
                With this data, the computed attitude for sensor visiblity takes
                into account a second target for attitude pointing. Usually,
                during maneuver, the spacecraft points the thruster towards a
                defined direction to execute a maneuver, leaving a degree of
                freedom to point another direction (here the solar panel)
                towards another target (here the Sun). With this, we ensure to
                give the maximum power to the spacecraft during the maneuver.
              </exo-help-dialog>
            </exo-input-double>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="10" v-if="isAdcsDesignType">
        <v-row>
          <v-col cols="6">
            <exo-input-ref
              :root="_self"
              name="initialOrbit"
              type="orbit"
              componentRoute="/analyticalorbit"
            />
            <div
              v-if="this.gt_OrbitTransferParam1.orbitsTourDone"
              gt_ParamOrbitTransfert1-v-step="30"
            ></div>
          </v-col>
          <v-col cols="6">
            <exo-input-date-time :root="_self" margin="mt-2" name="date" />
          </v-col>
        </v-row>
      </v-col>
      <exo-input-ref
        :root="_self"
        v-if="!isAdcsDesignType"
        name="initialOrbit"
        type="orbit"
        componentRoute="/analyticalorbit"
        :disableMultiple="isSequenceType"
        giveMeATour-v-step="14"
      />
      <div
        v-if="this.gt_OrbitTransferParam1.orbitsTourDone"
        gt_ParamOrbitTransfert1-v-step="30"
      ></div>
      <exo-input-ref
        :root="_self"
        v-if="isRAANType || isPositioningType"
        name="finalOrbit"
        type="orbit"
        componentRoute="/analyticalorbit"
        giveMeATour-v-step="15"
      />
      <div
        v-if="this.gt_OrbitTransferParam1.orbitsTourDone"
        gt_ParamOrbitTransfert1-v-step="31"
      ></div>
      <div v-if="isStationKeepingLEOType">
        <exo-input-parametric :root="_self" name="missionDuration" />
        <exo-input-parametric
          :root="_self"
          name="customSolarFlux"
          tooltip="Allows to take solar activity into account"
        >
          <tooltipCustomSolarFlux />
        </exo-input-parametric>

        <exo-input-select
          alignWithParametricField
          :root="_self"
          name="toleranceType"
          tooltip="Deviation allowed with respect to the initial orbit"
        />
        <exo-input-parametric
          :root="_self"
          name="smaTolerance"
          tooltip="Semi-major axis deviation allowed with respect to the initial orbit"
        />
        <exo-input-parametric
          :root="_self"
          name="alongTrackTolerance"
          tooltip="Along track deviation allowed with respect to the initial orbit"
        />

        <exo-form-alert
          type="warning"
          v-if="
            inputs.initialOrbit != null &&
            inputs.initialOrbit.altitude / 1000 - inputs.smaTolerance < 250
          "
        >
          WARNING: The altitude of the spacecraft will fall under the limit of
          250km, which will raise a computation error.
        </exo-form-alert>
      </div>

      <div fluid v-if="isArgumentOfLatitudePhasingType">
        <exo-input-select
          alignWithParametricField
          :root="_self"
          name="orbitPhasingOptimizationType"
        >
          <tooltipOrbitPhasingOptimizationType />
        </exo-input-select>
        <exo-input-parametric
          v-if="
            isArgumentOfLatitudePhasingDeltaVType ||
            isArgumentOfLatitudePhasingDeltaAolType
          "
          :root="_self"
          name="targetMissionDurationForAol"
          tooltip="Mission Duration"
        />
        <exo-input-parametric
          v-if="
            isArgumentOfLatitudePhasingDeltaVType ||
            isArgumentOfLatitudePhasingDeltaTType
          "
          :root="_self"
          name="targetDeltaArgumentOfLatitude"
          tooltip="AOL (Argument Of Latitude) = Argument Of Latitude (or In-Orbit Position), can be positive or negative"
        />
        <exo-input-parametric
          v-if="
            isArgumentOfLatitudePhasingDeltaTType ||
            isArgumentOfLatitudePhasingDeltaAolType
          "
          :root="_self"
          name="targetDeltaVmax"
          tooltip="ΔV budget for the phasing"
        />
      </div>
      <div fluid v-if="isRAANType">
        <exo-input-select
          alignWithParametricField
          :root="_self"
          name="raanPhasingReference"
        >
          <tooltipRaanPhasingReference />
        </exo-input-select>
        <exo-input-select
          alignWithParametricField
          :root="_self"
          name="optimizationType"
        >
          <tooltipOptimizationType />
        </exo-input-select>
        <exo-input-parametric :root="_self" name="targetMissionDuration" />
        <exo-input-parametric :root="_self" name="targetDeltaVmax" />
        <exo-input-select
          alignWithParametricField
          :root="_self"
          name="targetRaanLtanType"
        />
        <exo-input-parametric
          :root="_self"
          name="targetDeltaRaan"
          tooltip="RAAN = Right Ascension of Ascending Node"
        >
          <tooltipTargetDeltaRaan />
        </exo-input-parametric>
        <exo-input-parametric
          :root="_self"
          name="targetDeltaLtan"
          tooltip="MLTAN = Local Time of Ascending Node"
        >
          <tooltipTargetDeltaLtan />
        </exo-input-parametric>
        <exo-form-alert type="error" v-if="this.displayErrorTargetDeltaLtan">
          Error: ΔMLTAN must be different from 0h
        </exo-form-alert>
        <exo-input-select
          alignWithParametricField
          :root="_self"
          name="coastingDomain"
        >
          <tooltipCoastingDomain />
        </exo-input-select>
        <exo-input-parametric :root="_self" name="minCoastingAltitude" />
        <exo-form-alert type="error" v-if="minCoastingAltitudeErrorMessage">
          {{ minCoastingAltitudeErrorMessage }}
        </exo-form-alert>
        <exo-input-parametric :root="_self" name="maxCoastingAltitude" />
        <exo-form-alert type="error" v-if="maxCoastingAltitudeErrorMessage">
          {{ maxCoastingAltitudeErrorMessage }}
        </exo-form-alert>
        <exo-input-parametric :root="_self" name="minCoastingInclination" />
        <exo-form-alert type="error" v-if="minCoastingInclinationErrorMessage">
          {{ minCoastingInclinationErrorMessage }}
        </exo-form-alert>
        <exo-input-parametric :root="_self" name="maxCoastingInclination" />
        <exo-form-alert type="error" v-if="maxCoastingInclinationErrorMessage">
          {{ maxCoastingInclinationErrorMessage }}
        </exo-form-alert>
      </div>
      <div v-if="isSequenceType">
        <div v-if="isSequenceWithoutDeorbiting">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                small
                outlined
                v-on:click="addSubMissionPositioning"
                v-on="on"
              >
                <v-icon>add</v-icon>
                Orbital Transfer
              </v-btn>
            </template>
            <span>Add Orbital Transfer mission</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                small
                outlined
                v-on:click="addSubMissionRAAN"
                v-on="on"
              >
                <v-icon>add</v-icon>
                RAAN Phasing
              </v-btn>
            </template>
            <span>Add RAAN Phasing mission</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                small
                outlined
                v-on:click="addSubMissionArgumentOfLatitudePhasing"
                v-on="on"
              >
                <v-icon>add</v-icon>
                Orbit Phasing
              </v-btn>
            </template>
            <span>Add Orbit Phasing mission</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                small
                outlined
                v-on:click="addSubMissionStationKeepingLEO"
                v-on="on"
              >
                <v-icon>add</v-icon>
                LEO Station Keeping
              </v-btn>
            </template>
            <span>Add LEO Station keeping mission</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                small
                outlined
                v-on:click="addSubMissionDeorbiting"
                v-on="on"
              >
                <v-icon>add</v-icon>
                Deorbitation
              </v-btn>
            </template>
            <span>Add Deorbitation mission</span>
          </v-tooltip>
        </div>
        <exo-input-maneuver
          v-for="(maneuver, index) in inputs.subMissions"
          :key="maneuver.id"
          :maneuver="maneuver"
          :index="index"
          :root="_self"
        />
      </div>
      <div v-if="!isAdcsDesignType">
        <v-divider></v-divider>
        <exo-input-parametric
          :root="_self"
          label="Duration cost"
          name="durationCost"
          tooltip="Used to compute the mission cost"
        >
          <exo-help-dialog title="Cost functions">
            <tooltipCosts />
          </exo-help-dialog>
        </exo-input-parametric>
        <exo-input-parametric
          :root="_self"
          label="Mass cost"
          name="massCost"
          tooltip="Used to compute the mission cost"
        >
          <exo-help-dialog title="Cost functions">
            <tooltipCosts />
          </exo-help-dialog>
        </exo-input-parametric>
        <exo-form-alert v-if="useCosts" type="info">
          WARNING | Remember to provide costs for the propulsion system(s) (see
          cost functions tooltip above).
        </exo-form-alert>
      </div>
      <v-divider
        v-if="isRequiredOrOptional('scriptConfig', inputs)"
      ></v-divider>
      <exo-input-script
        name="scriptConfig"
        v-if="isRequiredOrOptional('scriptConfig', inputs)"
        :root="_self"
        :parentObject="inputs.scriptConfig"
      ></exo-input-script>
      <div giveMeATour-v-step="16"></div>
      <div
        v-if="this.gt_OrbitTransferParam1.orbitsTourDone"
        gt_ParamOrbitTransfert1-v-step="32"
      ></div>
      <div
        v-if="this.gt_OrbitTransferParam2.firstMissionTourDone"
        gt_ParamOrbitTransfert2-v-step="8"
      ></div>
    </exo-form>
    <v-col ref="AnalyticalMissionErrorDisplay"> </v-col>
    <v-tour name="analyticalMissionTour" :steps="steps"> </v-tour>
    <v-tour
      name="paramOrbitalTransfer1TourAnaMission"
      :steps="steps_analytical_mission"
      :callbacks="customCallbacks"
      :options="noSkipStepOption"
    ></v-tour>
    <v-tour
      name="paramOrbitalTransfer2TourAnaMission"
      :steps="steps_analytical_mission2"
      :callbacks="customCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import Vue from 'vue'
import formMixin from '../../mixins/forms.js'
import analyticalMixin from '../../mixins/analyticalFoms.js'
import dataTools from '../../tools/data.js'
import missionTools from '../../store/mission.js'
import fieldsDescription from '../../tools/fieldsDescription.json'
import resultsDescription from '../../tools/resultsDescription.json'
import dataDescription from '../../tools/dataDescription.json'
import scriptExampleMain from './ScriptExamples/main.txt'
import scriptExampleOrbitalTransfer from './ScriptExamples/orbitalTransfer.txt'
import scriptExampleRAANPhasing from './ScriptExamples/raanPhasing.txt'
import scriptExampleOrbitPhasing from './ScriptExamples/orbitPhasing.txt'
import scriptExampleLEOStationKeeping from './ScriptExamples/leoStationKeeping.txt'
import scriptExampleDeorbitation from './ScriptExamples/deorbitation.txt'
import scriptExampleSequence from './ScriptExamples/sequence.txt'
import scriptExampleADCSDesign from './ScriptExamples/adcsDesign.txt'
import tooltipCosts from '../../components/Tooltips/tooltipCosts'
import tooltipParametricADCSDesign from '../../components/Tooltips/tooltipParametricADCSDesign'
import tooltipParametricOrbitalTransfer from '../../components/Tooltips/tooltipParametricOrbitalTransfer'
import tooltipParametricOrbitPhasing from '../../components/Tooltips/tooltipParametricOrbitPhasing'
import tooltipParametricRAANPhasing from '../../components/Tooltips/tooltipParametricRAANPhasing'
import tooltipParametricLEOStationKeeping from '../../components/Tooltips/tooltipParametricLEOStationKeeping'
import tooltipParametricDeorbitation from '../../components/Tooltips/tooltipParametricDeorbitation'
import tooltipParametricSequenceOfMissions from '../../components/Tooltips/tooltipParametricSequenceOfMissions'
import tooltipEnableMassLossAfterManeuvers from '../../components/Tooltips/AnalyticalMission/tooltipEnableMassLossAfterManeuvers'
import tooltipDragPerturbationEnabled from '../../components/Tooltips/AnalyticalMission/tooltipDragPerturbationEnabled'
import tooltipCustomSolarFlux from '../../components/Tooltips/AnalyticalMission/tooltipCustomSolarFlux'
import tooltipOrbitPhasingOptimizationType from '../../components/Tooltips/AnalyticalMission/tooltipOrbitPhasingOptimizationType'
import tooltipRaanPhasingReference from '../../components/Tooltips/AnalyticalMission/tooltipRaanPhasingReference'
import tooltipOptimizationType from '../../components/Tooltips/AnalyticalMission/tooltipOptimizationType'
import tooltipTargetDeltaRaan from '../../components/Tooltips/AnalyticalMission/tooltipTargetDeltaRaan'
import tooltipTargetDeltaLtan from '../../components/Tooltips/AnalyticalMission/tooltipTargetDeltaLtan'
import tooltipCoastingDomain from '../../components/Tooltips/AnalyticalMission/tooltipCoastingDomain'
import { mapGetters, mapActions } from 'vuex'
import guidedTutorialParamOrbitalTransfer1, {
  steps_analytical_mission
} from '../../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer1.js'
import { noSkipStepOption } from '../../components/GuidedTutorials/guidedTutorialConstraints.js'
import guidedTutorialParamOrbitalTransfer2, {
  steps_analytical_mission2
} from '../../components/GuidedTutorials/guidedTutorialParamOrbitalTransfer2.js'

export default {
  name: 'analyticalmission',

  mixins: [formMixin, analyticalMixin],

  components: {
    tooltipCosts,
    tooltipParametricADCSDesign,
    tooltipParametricOrbitalTransfer,
    tooltipParametricOrbitPhasing,
    tooltipParametricRAANPhasing,
    tooltipParametricLEOStationKeeping,
    tooltipParametricDeorbitation,
    tooltipParametricSequenceOfMissions,
    tooltipEnableMassLossAfterManeuvers,
    tooltipDragPerturbationEnabled,
    tooltipCustomSolarFlux,
    tooltipOrbitPhasingOptimizationType,
    tooltipRaanPhasingReference,
    tooltipOptimizationType,
    tooltipTargetDeltaRaan,
    tooltipTargetDeltaLtan,
    tooltipCoastingDomain
  },

  async mounted() {
    this.$root.$on('copy-mission', this.copyMissionHandler)
    this.$root.$on('create-mission', this.createMissionHandler)
    this.$root.$on('current-mission-updated', this.currentMissionUpdatedHandler)
    await this.refreshSpacecrafts()
    await this.refreshOrbits()
    this.refreshForm()

    if (this.giveMeATour) {
      this.$tours['analyticalMissionTour'].start()
    }
    if (this.gt_OrbitTransferParam1.isActive) {
      guidedTutorialParamOrbitalTransfer1.beginParamOrbitalTranfer1Tour(this)
    }
    if (this.gt_OrbitTransferParam2.isActive) {
      guidedTutorialParamOrbitalTransfer2.beginParamOrbitalTranfer2Tour(this)
    }
  },

  beforeDestroy() {
    this.$root.$off('copy-mission', this.copyMissionHandler)
    this.$root.$off('create-mission', this.createMissionHandler)
    this.$root.$off(
      'current-mission-updated',
      this.currentMissionUpdatedHandler
    )
  },

  computed: {
    ...mapGetters([
      'currentMission',
      'giveMeATour',
      'gt_OrbitTransferParam1',
      'gt_OrbitTransferParam2'
    ]),
    useCosts() {
      return (
        (this.inputs.massCost != null && this.inputs.massCost !== '') ||
        (this.inputs.durationCost != null && this.inputs.durationCost !== '')
      )
    },
    isPositioningType() {
      return this.isPositioningMission(this.inputs)
    },
    isDeorbitingType() {
      return this.isDeorbitingMission(this.inputs)
    },
    isArgumentOfLatitudePhasingType() {
      return this.isArgumentOfLatitudePhasingMission(this.inputs)
    },
    isArgumentOfLatitudePhasingDeltaAolType() {
      return this.isArgumentOfLatitudePhasingDeltaAol(this.inputs)
    },
    isArgumentOfLatitudePhasingDeltaVType() {
      return this.isArgumentOfLatitudePhasingDeltaV(this.inputs)
    },
    isArgumentOfLatitudePhasingDeltaTType() {
      return this.isArgumentOfLatitudePhasingDeltaT(this.inputs)
    },
    isStationKeepingLEOType() {
      return this.isStationKeepingLEOMission(this.inputs)
    },
    isRAANType() {
      return this.isRAANMission(this.inputs)
    },
    isAdcsDesignType() {
      return this.isAdcsDesignMission(this.inputs)
    },
    isSequenceType() {
      return this.isSequenceMission(this.inputs)
    },
    isSequenceWithoutDeorbiting() {
      if (this.isSequenceType) {
        let nbSubMissions = this.inputs.subMissions.length
        if (nbSubMissions > 0) {
          return !this.isDeorbitingMission(
            this.inputs.subMissions[nbSubMissions - 1]
          )
        } else {
          return true
        }
      } else {
        return false
      }
    },

    minCoastingAltitudeErrorMessage() {
      if (
        Number(this.inputs.initialOrbit?.altitude / 1000) <
        Number(this.inputs.minCoastingAltitude)
      ) {
        return 'Min coasting altitude must be lower than initial orbit altitude.'
      }
      if (
        Number(this.inputs.finalOrbit?.altitude / 1000) <
        Number(this.inputs.minCoastingAltitude)
      ) {
        return 'Min coasting altitude must be lower than final orbit altitude.'
      }
      return false
    },

    maxCoastingAltitudeErrorMessage() {
      if (
        Number(this.inputs.initialOrbit?.altitude / 1000) >
        Number(this.inputs.maxCoastingAltitude)
      ) {
        return 'Max coasting altitude must be higher than initial orbit altitude.'
      }
      if (
        Number(this.inputs.finalOrbit?.altitude / 1000) >
        Number(this.inputs.maxCoastingAltitude)
      ) {
        return 'Max coasting altitude must be higher than final orbit altitude.'
      }
      return false
    },

    minCoastingInclinationErrorMessage() {
      if (
        dataTools.rad2deg(Number(this.inputs.initialOrbit?.inclination)) <
        Number(this.inputs.minCoastingInclination)
      ) {
        return 'Min coasting inclination must be lower than initial orbit inclination.'
      }
      if (
        dataTools.rad2deg(Number(this.inputs.finalOrbit?.inclination)) <
        Number(this.inputs.minCoastingInclination)
      ) {
        return 'Min coasting inclination must be lower than final orbit inclination.'
      }
      return false
    },

    maxCoastingInclinationErrorMessage() {
      if (
        dataTools.rad2deg(Number(this.inputs.initialOrbit?.inclination)) >
        Number(this.inputs.maxCoastingInclination)
      ) {
        return 'Max coasting inclination must be higher than initial orbit inclination.'
      }
      if (
        dataTools.rad2deg(Number(this.inputs.finalOrbit?.inclination)) >
        Number(this.inputs.maxCoastingInclination)
      ) {
        return 'Max coasting inclination must be higher than final orbit inclination.'
      }
      return false
    },

    displayErrorTargetDeltaLtan() {
      if (this.inputs.parametricValues.targetDeltaLtan.active) {
        return (
          dataTools.convertGui2si(
            'timeHMS',
            this.inputs.parametricValues.targetDeltaLtan.min
          ) === 0
        )
      } else {
        return (
          dataTools.convertGui2si('timeHMS', this.inputs.targetDeltaLtan) === 0
        )
      }
    },

    inputsValid() {
      let requiredList = this.getRequiredPropertiesList(this.inputs)
      let fieldsState = this.verifyPropertiesList(
        requiredList,
        this.inputs,
        true
      )
      let optionalList = this.getOptionalPropertiesListWithoutScriptFields(
        this.inputs
      )
      fieldsState =
        fieldsState &&
        this.verifyPropertiesList(optionalList, this.inputs, false)
      if (this.inputs.type === 'Sequence') {
        if (this.inputs.subMissions.length === 0) {
          fieldsState = false
        }
        let missions = this.inputs.subMissions
        for (let subMission in missions) {
          let requiredListSubMission = this.getRequiredPropertiesList(
            missions[subMission]
          )
          requiredListSubMission = requiredListSubMission.filter(
            (val) => !requiredList.includes(val)
          )
          fieldsState =
            fieldsState &&
            this.verifyPropertiesList(
              requiredListSubMission,
              missions[subMission],
              true
            )
        }
      }
      return this.inputNameState && fieldsState
    }
  },

  data() {
    return {
      tableFields: [
        { key: 'displayedName', label: 'Name', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'spacecraft', label: 'Spacecraft', sortable: true },
        { key: 'initialOrbit', label: 'Initial orbit', sortable: true },
        { key: 'finalOrbit', label: 'Final orbit', sortable: true },
        {
          key: 'missionDuration',
          label:
            'Mission duration' +
            this.getResultDefaultUnitLabel('missionDuration'),
          sortable: true
        },
        {
          key: 'deltaV',
          label: 'ΔV' + this.getResultDefaultUnitLabel('deltaV'),
          sortable: true
        },
        {
          key: 'usedPropellant',
          label:
            'Used propellant' + this.getResultDefaultUnitLabel('usedPropellant')
        },
        { key: 'results', label: 'Results' },
        { key: 'actions', label: 'Actions' }
      ],
      noSkipStepOption: noSkipStepOption,
      customCallbacks: {
        onNextStep: (currentStep) => {
          if (this.gt_OrbitTransferParam2.isActive) {
            guidedTutorialParamOrbitalTransfer2.onNextAnaMission(
              this,
              currentStep
            )
          } else if (this.gt_OrbitTransferParam1.isActive) {
            guidedTutorialParamOrbitalTransfer1.onNextStepAnaMission(
              currentStep,
              this
            )
          }
        },
        onSkip: () => {
          guidedTutorialParamOrbitalTransfer1.stopAllTours(this)
          if (this.gt_OrbitTransferParam2.isActive) {
            guidedTutorialParamOrbitalTransfer2.onSkipAnaMission(this)
          }
        },
        onFinish: () => {
          guidedTutorialParamOrbitalTransfer1.onFinishAnaMission(this)
        }
      },

      orbits: [],
      spacecrafts: [],
      initialLtan: [],
      tipOffRateX: [],
      tipOffRateY: [],
      tipOffRateZ: [],
      solarArrayNormalX: [],
      solarArrayNormalY: [],
      solarArrayNormalZ: [],
      attitudeModes: [],
      orbitsNotParametrics: [],
      orbitsNotParametricsId: [],
      spacecraftsNotParametricsId: [],

      enumPropertiesList: this.getEnumProperties(),

      modalRef: { content: [] },
      showModal: false,

      missionPlot: null,
      initialScriptHelp: scriptExampleMain,
      customInputsScriptHelp: '/* Custom inputs\n*/',
      inputs: {
        type: this.getDefaultValue('type'),
        scriptConfig: {
          enableScript: false,
          script: '',
          scriptInputs: {}
        },
        initialOrbit: null,
        finalOrbit: null,
        date: this.getDefaultValue('date'),
        missionDuration: this.getDefaultValue('missionDuration'),
        targetMissionDuration: this.getDefaultValue('targetMissionDuration'),
        targetMissionDurationForAol: this.getDefaultValue(
          'targetMissionDurationForAol'
        ),
        fastADCSComputation: this.getDefaultValue('fastADCSComputation'),
        targetDeltaRaan: this.getDefaultValue('targetDeltaRaan'),
        targetDeltaLtan: this.getDefaultValue('targetDeltaLtan'),
        targetRaanLtanType: this.getDefaultValue('targetRaanLtanType'),
        targetDeltaVmax: this.getDefaultValue('targetDeltaVmax'),
        targetDeltaArgumentOfLatitude: this.getDefaultValue(
          'targetDeltaArgumentOfLatitude'
        ),
        dragPerturbationEnabled: this.getDefaultValue(
          'dragPerturbationEnabled'
        ),
        optimizationType: this.getDefaultValue('optimizationType'),
        raanPhasingReference: this.getDefaultValue('raanPhasingReference'),
        coastingDomain: this.getDefaultValue('coastingDomain'),
        minCoastingAltitude: this.getDefaultValue('minCoastingAltitude'),
        maxCoastingAltitude: this.getDefaultValue('maxCoastingAltitude'),
        minCoastingInclination: this.getDefaultValue('minCoastingInclination'),
        maxCoastingInclination: this.getDefaultValue('maxCoastingInclination'),
        orbitPhasingOptimizationType: this.getDefaultValue(
          'orbitPhasingOptimizationType'
        ),
        spacecraft: null,
        attitudeMode: this.getDefaultValue('attitudeMode'),
        initialLtan: this.getDefaultValue('initialLtan'),
        tipOffRateX: this.getDefaultValue('tipOffRateX'),
        tipOffRateY: this.getDefaultValue('tipOffRateY'),
        tipOffRateZ: this.getDefaultValue('tipOffRateZ'),
        solarArrayNormalX: this.getDefaultValue('solarArrayNormalX'),
        solarArrayNormalY: this.getDefaultValue('solarArrayNormalY'),
        solarArrayNormalZ: this.getDefaultValue('solarArrayNormalZ'),
        massCost: this.getDefaultValue('massCost'),
        durationCost: this.getDefaultValue('durationCost'),
        customSolarFlux: this.getDefaultValue('customSolarFlux'),
        smaTolerance: this.getDefaultValue('smaTolerance'),
        alongTrackTolerance: this.getDefaultValue('alongTrackTolerance'),
        toleranceType: this.getDefaultValue('toleranceType'),
        subMissions: [],
        massLossAfterSubMissions: [],
        enableMassLossAfterSubMissions: this.getDefaultValue(
          'enableMassLossAfterSubMissions'
        ),
        layout: this.getDefaultValue('layout'), // to save the dashboard, should be optional in fieldsdesscription to be automatically cpoied
        parametricReferences: {
          initialOrbit: this.buildDefaultParametricReference('initialOrbit'),
          finalOrbit: this.buildDefaultParametricReference('finalOrbit'),
          spacecraft: this.buildDefaultParametricReference('spacecraft')
        },
        parametricValues: {
          missionDuration: this.buildDefaultParametricValue('missionDuration'),
          attitudeMode: this.buildDefaultParametricValue('attitudeMode'),
          initialLtan: this.buildDefaultParametricValue('initialLtan'),
          tipOffRateX: this.buildDefaultParametricValue('tipOffRateX'),
          tipOffRateY: this.buildDefaultParametricValue('tipOffRateY'),
          tipOffRateZ: this.buildDefaultParametricValue('tipOffRateZ'),
          solarArrayNormalX:
            this.buildDefaultParametricValue('solarArrayNormalX'),
          solarArrayNormalY:
            this.buildDefaultParametricValue('solarArrayNormalY'),
          solarArrayNormalZ:
            this.buildDefaultParametricValue('solarArrayNormalZ'),
          targetMissionDuration: this.buildDefaultParametricValue(
            'targetMissionDuration'
          ),
          targetMissionDurationForAol: this.buildDefaultParametricValue(
            'targetMissionDurationForAol'
          ),
          targetDeltaRaan: this.buildDefaultParametricValue('targetDeltaRaan'),
          targetDeltaLtan: this.buildDefaultParametricValue('targetDeltaLtan'),
          targetDeltaVmax: this.buildDefaultParametricValue('targetDeltaVmax'),
          targetDeltaArgumentOfLatitude: this.buildDefaultParametricValue(
            'targetDeltaArgumentOfLatitude'
          ),
          customSolarFlux: this.buildDefaultParametricValue('customSolarFlux'),
          toleranceType: this.buildDefaultParametricValue('ToleranceType'),
          smaTolerance: this.buildDefaultParametricValue('smaTolerance'),
          alongTrackTolerance: this.buildDefaultParametricValue(
            'alongTrackTolerance'
          ),
          massCost: this.buildDefaultParametricValue('massCost'),
          durationCost: this.buildDefaultParametricValue('durationCost'),
          minCoastingAltitude: this.buildDefaultParametricValue(
            'minCoastingAltitude'
          ),
          maxCoastingAltitude: this.buildDefaultParametricValue(
            'maxCoastingAltitude'
          ),
          minCoastingInclination: this.buildDefaultParametricValue(
            'minCoastingInclination'
          ),
          maxCoastingInclination: this.buildDefaultParametricValue(
            'maxCoastingInclination'
          )
        }
      },
      steps: [
        {
          target: '[giveMeATour-v-step="11"]',
          content:
            'We are now on the <strong>creation</strong> of an <strong>orbital transfer</strong> mission.'
        },
        {
          target: '[giveMeATour-v-step="12"]',
          content:
            'Let\'s first give a <strong>name</strong> to the mission. Set it to "Analytical mission test".'
        },
        {
          target: '[giveMeATour-v-step="13"]',
          content: 'Choose a <strong>Spacecraft</strong> from the list.'
        },
        {
          target: '[giveMeATour-v-step="14"]',
          content: 'Select an <strong>initial orbit</strong>.'
        },
        {
          target: '[giveMeATour-v-step="15"]',
          content: 'Select a <strong>final orbit</strong>.'
        },
        {
          target: '[giveMeATour-v-step="16"]',
          content:
            'The <strong>"Save"</strong> button is now available. Click on it to compute the mission.'
        }
      ],
      steps_analytical_mission: steps_analytical_mission,
      steps_analytical_mission2: steps_analytical_mission2,

      modalInfo: { title: '', content: '', errorLog: '' },
      modalError: { title: '', content: '' },

      newCustomFieldName: '',
      forceUpdateComputed: 0
    }
  },

  methods: {
    ...mapActions(['setCurrentMission', 'start_gt_OrbitTransferParam1']),
    refreshTable() {},

    currentMissionUpdatedHandler() {
      this.refreshForm()
    },

    createMissionHandler(mission) {
      this.createMission(mission)
    },

    copyMissionHandler(mission) {
      this.copyMission(mission)
    },

    addNewCustomField() {
      if (this.inputs.parametricValues[this.newCustomFieldName]) {
        return
      }
      if (this.inputs.scriptConfig.scriptInputs[this.newCustomFieldName]) {
        return
      }
      if (this.getPropertiesDescription()[this.newCustomFieldName] != null) {
        return // 'Field ' + fieldName + ' already exists and can not be used for custom inputs'
      }
      let paramDef = this.buildDefaultParametricValueForCustomField()
      paramDef.active = true // input only useful if parametric
      Vue.set(this.inputs.parametricValues, this.newCustomFieldName, paramDef)
      this.inputs.scriptConfig.scriptInputs[this.newCustomFieldName] = {
        value: null,
        unit: '',
        type: ''
      }
      this.updateScriptInput()
      this.newCustomFieldName = ''
    },
    deleteCustomField(key) {
      this.inputs.scriptConfig.scriptInputs[key] = null
      this.inputs.parametricValues[key] = null
      delete this.inputs.scriptConfig.scriptInputs[key]
      delete this.inputs.parametricValues[key]
      this.updateScriptInput()
    },

    getMissionSpecificScriptHelp(type) {
      let scriptHelp = ''
      if (type === 'RAAN Phasing') {
        scriptHelp += scriptExampleRAANPhasing
      } else if (type === 'Orbital Transfer') {
        scriptHelp += scriptExampleOrbitalTransfer
      } else if (type === 'Orbit Phasing') {
        scriptHelp += scriptExampleOrbitPhasing
      } else if (type === 'LEO Station Keeping') {
        scriptHelp += scriptExampleLEOStationKeeping
      } else if (type === 'Deorbitation') {
        scriptHelp += scriptExampleDeorbitation
      } else if (type === 'Sequence') {
        scriptHelp += scriptExampleSequence
        this.inputs.subMissions.forEach((subMission) => {
          scriptHelp += this.getMissionSpecificScriptHelp(subMission.type)
        })
      } else if (type === 'ADCS Design') {
        scriptHelp += scriptExampleADCSDesign
      }
      return scriptHelp
    },

    initScriptInput() {
      // to build the main help bloc, use http://asciiflow.com/
      let script = this.inputs.scriptConfig.script
      if (script !== '' && script !== null) {
        return
      }
      this.inputs.scriptConfig.script += '/*\n'
      this.inputs.scriptConfig.script += this.initialScriptHelp
      this.inputs.scriptConfig.script += this.getMissionSpecificScriptHelp(
        this.inputs.type
      )
      this.inputs.scriptConfig.script += '*/\n'
      this.inputs.scriptConfig.script += this.customInputsScriptHelp
      this.inputs.scriptConfig.script +=
        "\nvar exports = {}\nexports // don't delete this line"
    },

    addSubMissionHelpToScript(subMission) {
      let insertPosition = this.inputs.scriptConfig.script.indexOf('*/')
      let script = this.inputs.scriptConfig.script
      this.inputs.scriptConfig.script = [
        script.slice(0, insertPosition),
        this.getMissionSpecificScriptHelp(subMission.type),
        script.slice(insertPosition)
      ].join('')
    },

    removeSubMissionHelpToScript(subMission) {
      let toRemove = this.getMissionSpecificScriptHelp(subMission.type)
      this.inputs.scriptConfig.script = this.inputs.scriptConfig.script.replace(
        toRemove,
        ''
      )
    },

    updateScriptInput() {
      let script = this.inputs.scriptConfig.script
      let startOfCustomInputs = script.lastIndexOf('/*')
      let endOfCustomInputs = script.lastIndexOf('*/')
      let firstPart = script.substr(0, startOfCustomInputs)
      let secondPart = script.substr(endOfCustomInputs + 2, script.length)
      let newScript = firstPart + '/* Custom Inputs\n'
      for (let field in this.inputs.scriptConfig.scriptInputs) {
        newScript += '  ' + field + '\n'
      }
      newScript += '*/' + secondPart
      this.inputs.scriptConfig.script = newScript
    },

    getCurrentFormTitle() {
      const label = dataTools.getTypeLabel(
        this.getCurrentFormType(),
        this.inputs.type
      )
      return label + ' Parametric Study'
    },

    // TODO many methods are copied between numerical and analytical classes : create mixins
    createMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.clearForm()
        this.inputs.type = mission.type
        this.sendFormToServer()
      }
    },

    copyMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.copy(mission)
        this.sendFormToServer()
      }
    },

    refreshForm() {
      if (
        this.currentMission != null &&
        this.currentMission.typeName === this.getCurrentFormType()
      ) {
        if (this.currentMission.id !== this.inputs.id) {
          // different mission reload completely the form
          this.edit(this.currentMission, 0)
        } else {
          // reloading the current mission
          // only refresh the updated fields
          this.updateAllReferences()
          this.inputs.layout = this.currentMission.layout // might be saved from dashboard
        }
      }
    },

    updateAllReferences() {
      const fieldsToUpdate = [this.orbits, this.spacecrafts]
      missionTools.updateAllReferences(this, fieldsToUpdate)
      if (this.isSequenceType) {
        for (let i = 0; i < this.currentMission.subMissions.length; i++) {
          let currentSubMission = this.currentMission.subMissions[i]
          let inputsSubMission = this.inputs.subMissions[i]
          missionTools.checkReferences(currentSubMission, inputsSubMission)
        }
      }
    },

    sendFormToServer() {
      this.inputs.saving = true
      this.$http
        .post(this.getCurrentAPI(), this.createObjectFromForm())
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('set-current-mission', response.data)
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'AnalyticalMissionErrorDisplay',
            'error'
          )
        })
    },

    // redefine from form.js to keep the form open on the updated data
    onSave: function (evt) {
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then((response) => {
          this.inputs.saving = false
          this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard

          this.$router.push({
            path:
              '/' +
              missionTools.missionUrlMapping[response.data.typeName].dashboard
          })
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'AnalyticalMissionErrorDisplay',
            'error'
          )
        })
    },
    getRequiredPropertiesList(instance) {
      let missionType = this.getMissionType(instance)
      let objectType = this.getCurrentFormType()
      let requiredProperties = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        missionType,
        'required'
      )
      return requiredProperties
    },

    getOptionalPropertiesList(instance) {
      let missionType = this.getMissionType(instance)
      let objectType = this.getCurrentFormType()
      const optionalProperties = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        missionType,
        'optional'
      )
      // add script inputs  (to be displayed in form)
      if (this.inputs.scriptConfig != null) {
        for (let field in this.inputs.scriptConfig.scriptInputs) {
          optionalProperties.push(field)
        }
      }
      return optionalProperties
    },

    getOptionalPropertiesListWithoutScriptFields(instance) {
      let missionType = this.getMissionType(instance)
      let objectType = this.getCurrentFormType()
      const optionalProperties = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        missionType,
        'optional'
      )
      return optionalProperties
    },

    getAllPropertiesUnionList() {
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'required'
      )
      let optionalList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        null,
        'optional'
      )
      return [...new Set(requiredList.concat(optionalList))]
    },

    getMissionType(mission) {
      let types = { type: mission.type }
      if (mission.type === 'RAAN Phasing') {
        types.optimizationType = mission.optimizationType
        types.targetRaanLtanType = mission.targetRaanLtanType
        types.coastingDomain = mission.coastingDomain
      }
      if (mission.type === 'Orbit Phasing') {
        types.orbitPhasingOptimizationType =
          mission.orbitPhasingOptimizationType
      }
      if (mission.type === 'LEO Station Keeping') {
        types.toleranceType = mission.toleranceType
      }
      return types
    },

    getResultFieldType(field) {
      return resultsDescription[
        this.getCurrentFormType().replace('Request', 'Result')
      ][field].type
    },

    getResultDefaultUnitLabel(field) {
      let fieldType = this.getResultFieldType(field)
      return (
        ' ' + dataTools.getUnitLabel(dataTools.getDefaultGuiUnit(fieldType))
      )
    },

    // Methods to display results

    getMissionItem(mission) {
      if (mission.constructor === Array) {
        return mission[0]
      } else {
        return mission
      }
    },

    isMissionType(mission, type) {
      let firstMission = this.getMissionItem(mission)
      if (firstMission == null) {
        return false
      }
      return firstMission.type === type
    },

    isPositioningMission(mission) {
      return this.isMissionType(mission, 'Orbital Transfer')
    },

    isArgumentOfLatitudePhasingMission(mission) {
      return this.isMissionType(mission, 'Orbit Phasing')
    },

    isArgumentOfLatitudePhasingDeltaAol(mission) {
      return (
        this.isArgumentOfLatitudePhasingMission(mission) &&
        this.getMissionItem(mission).orbitPhasingOptimizationType ===
          'DELTA_AOL'
      )
    },

    isArgumentOfLatitudePhasingDeltaV(mission) {
      return (
        this.isArgumentOfLatitudePhasingMission(mission) &&
        this.getMissionItem(mission).orbitPhasingOptimizationType === 'DELTA_V'
      )
    },

    isArgumentOfLatitudePhasingDeltaT(mission) {
      return (
        this.isArgumentOfLatitudePhasingMission(mission) &&
        this.getMissionItem(mission).orbitPhasingOptimizationType === 'DELTA_T'
      )
    },
    isStationKeepingLEOMission(mission) {
      return this.isMissionType(mission, 'LEO Station Keeping')
    },

    isDeorbitingMission(mission) {
      return this.isMissionType(mission, 'Deorbitation')
    },

    isRAANMission(mission) {
      return this.isMissionType(mission, 'RAAN Phasing')
    },

    isAdcsDesignMission(mission) {
      return this.isMissionType(mission, 'ADCS Design')
    },

    isSequenceMission(mission) {
      return this.isMissionType(mission, 'Sequence')
    },
    /// /////////////////////
    checkFieldIsArray(fieldName) {
      if (
        this.inputs[fieldName] == null ||
        !Array.isArray(this.inputs[fieldName])
      ) {
        Vue.set(this.inputs, fieldName, [])
      }
    },
    addSubMissionExtraField() {
      this.checkFieldIsArray('massLossAfterSubMissions')
      this.inputs.massLossAfterSubMissions.push(0)
    },

    addSubMissionArgumentOfLatitudePhasing() {
      this.addSubMissionExtraField()
      this.inputs.subMissions.push({
        type: 'Orbit Phasing',
        targetDeltaVmax: this.getDefaultValue('targetDeltaVmax'),
        targetDeltaArgumentOfLatitude: this.getDefaultValue(
          'targetDeltaArgumentOfLatitude'
        ),
        targetMissionDurationForAol: this.getDefaultValue(
          'targetMissionDurationForAol'
        ),
        orbitPhasingOptimizationType: this.getDefaultValue(
          'orbitPhasingOptimizationType'
        ),
        parametricValues: {
          targetDeltaVmax: this.buildDefaultParametricValue('targetDeltaVmax'),
          targetDeltaArgumentOfLatitude: this.buildDefaultParametricValue(
            'targetDeltaArgumentOfLatitude'
          ),
          targetMissionDurationForAol: this.buildDefaultParametricValue(
            'targetMissionDurationForAol'
          )
        }
      })
      this.addSubMissionHelpToScript(
        this.inputs.subMissions[this.inputs.subMissions.length - 1]
      )
    },

    addSubMissionStationKeepingLEO() {
      this.addSubMissionExtraField()
      this.inputs.subMissions.push({
        type: 'LEO Station Keeping',
        missionDuration: this.getDefaultValue('missionDuration'),
        customSolarFlux: this.getDefaultValue('customSolarFlux'),
        toleranceType: this.getDefaultValue('toleranceType'),
        smaTolerance: this.getDefaultValue('smaTolerance'),
        alongTrackTolerance: this.getDefaultValue('alongTrackTolerance'),

        parametricValues: {
          missionDuration: this.buildDefaultParametricValue('missionDuration'),
          customSolarFlux: this.buildDefaultParametricValue('customSolarFlux'),
          toleranceType: this.buildDefaultParametricValue('toleranceType'),
          smaTolerance: this.getDefaultValue('smaTolerance'),
          alongTrackTolerance: this.getDefaultValue('alongTrackTolerance')
        }
      })
      this.addSubMissionHelpToScript(
        this.inputs.subMissions[this.inputs.subMissions.length - 1]
      )
    },

    addSubMissionDeorbiting() {
      this.addSubMissionExtraField()
      this.inputs.subMissions.push({
        type: 'Deorbitation'
      })
      this.addSubMissionHelpToScript(
        this.inputs.subMissions[this.inputs.subMissions.length - 1]
      )
    },

    addSubMissionRAAN() {
      this.addSubMissionExtraField()
      this.inputs.subMissions.push({
        type: 'RAAN Phasing',
        finalOrbit: null,
        targetMissionDuration: this.getDefaultValue('targetMissionDuration'),
        targetDeltaRaan: this.getDefaultValue('targetDeltaRaan'),
        targetDeltaVmax: this.getDefaultValue('targetDeltaVmax'),
        targetDeltaLtan: this.getDefaultValue('targetDeltaLtan'),
        targetRaanLtanType: this.getDefaultValue('targetRaanLtanType'),
        raanPhasingReference: this.getDefaultValue('raanPhasingReference'),
        dragPerturbationEnabled: this.getDefaultValue(
          'dragPerturbationEnabled'
        ),
        optimizationType: this.getDefaultValue('optimizationType'),
        coastingDomain: this.getDefaultValue('coastingDomain'),
        minCoastingAltitude: this.getDefaultValue('minCoastingAltitude'),
        maxCoastingAltitude: this.getDefaultValue('maxCoastingAltitude'),
        minCoastingInclination: this.getDefaultValue('minCoastingInclination'),
        maxCoastingInclination: this.getDefaultValue('maxCoastingInclination'),
        parametricReferences: {
          finalOrbit: this.buildDefaultParametricReference('finalOrbit')
        },
        parametricValues: {
          targetMissionDuration: this.buildDefaultParametricValue(
            'targetMissionDuration'
          ),
          targetDeltaRaan: this.buildDefaultParametricValue('targetDeltaRaan'),
          targetDeltaLtan: this.buildDefaultParametricValue('targetDeltaLtan'),
          targetDeltaVmax: this.buildDefaultParametricValue('targetDeltaVmax'),
          minCoastingAltitude: this.buildDefaultParametricValue(
            'minCoastingAltitude'
          ),
          maxCoastingAltitude: this.buildDefaultParametricValue(
            'maxCoastingAltitude'
          ),
          minCoastingInclination: this.buildDefaultParametricValue(
            'minCoastingInclination'
          ),
          maxCoastingInclination: this.buildDefaultParametricValue(
            'maxCoastingInclination'
          )
        }
      })
      this.addSubMissionHelpToScript(
        this.inputs.subMissions[this.inputs.subMissions.length - 1]
      )
    },

    addSubMissionPositioning() {
      this.addSubMissionExtraField()
      this.inputs.subMissions.push({
        type: 'Orbital Transfer',
        finalOrbit: null,
        parametricReferences: {
          finalOrbit: this.buildDefaultParametricReference('finalOrbit')
        }
      })
      this.addSubMissionHelpToScript(
        this.inputs.subMissions[this.inputs.subMissions.length - 1]
      )
    },

    removeSubMission(index) {
      this.removeSubMissionHelpToScript(this.inputs.subMissions[index])
      this.inputs.subMissions.splice(index, 1)
      this.checkFieldIsArray('massLossAfterSubMissions')
      this.inputs.massLossAfterSubMissions.splice(index, 1)
    },

    // Methods to manage result popup
    info() {
      this.modalInfo.title = this.currentMission.name
      this.modalInfo.content = this.currentResultsLog.results
      this.modalInfo.errorLog = this.currentMission.computationLog
      this.$router.push({ path: '/analyticaldashboard' })
      // this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },
    resetModal() {
      this.modalInfo.title = ''
      this.modalInfo.content = ''
      this.modalInfo.errorLog = ''
      this.modalError.title = ''
      this.modalError.content = ''
    },

    // Methods to compute &  export results

    // TODO MFI delete ?
    displayErrorLog(mission, button) {
      this.modalInfo.title = mission.name
      this.modalInfo.content = mission.computationLog
      this.$root.$emit('bv::show::modal', 'modalInfo', button)
    },

    // methods to mange form & table like other components

    clearLocalFields() {
      for (let field in this.getPropertiesDescription()) {
        if (this.inputs.hasOwnProperty(field)) {
          this.inputs[field] = this.getDefaultValue(field)
          let fieldType = this.getPropertiesDescription()[field].type
          if (dataDescription[fieldType] != null) {
            this.checkParametricValue(this.inputs, field)
          } else if (fieldsDescription[fieldType] != null) {
            this.checkParametricReference(this.inputs, field)
          }
        }
      }
      this.inputs.subMissions = []
      this.inputs.massLossAfterSubMissions = []
    },

    copyLocalFields(item) {
      this.copyFieldsToBaseObject(item, this.inputs)
      if (this.isSequenceType) {
        Vue.set(this.inputs, 'subMissions', [])
        for (let subMission of item.subMissions) {
          let subMissionDef = {
            type: subMission.type,
            parametricValues: {},
            parametricReferences: {}
          }
          this.copyFieldsToBaseObject(subMission, subMissionDef)
          this.inputs.subMissions.push(subMissionDef)
        }
      }
    },

    addLocalFieldsFromForm(baseObject, fieldsList) {
      baseObject = this.addFieldsListToBaseObject(baseObject, fieldsList)
      baseObject.computationRequested = true
      if (this.isSequenceType) {
        let initialOrbit = this.inputs.initialOrbit
        let spacecraft = this.inputs.spacecraft
        let attitudeMode = this.inputs.attitudeMode
        baseObject.subMissions = []
        for (let subMission in this.inputs.subMissions) {
          let subMissionDef = this.inputs.subMissions[subMission]
          let subMissionBaseObject = {
            id: 0,
            name: 'Manoeuvre ' + subMission + ' : ' + subMissionDef.type,
            type: subMissionDef.type,
            initialOrbit: initialOrbit,
            spacecraft: spacecraft,
            attitudeMode: attitudeMode,
            results: null
          }
          let fieldsListSubMission =
            this.getRequiredPropertiesList(subMissionDef)
          fieldsListSubMission = fieldsListSubMission.filter(
            (val) => !fieldsList.includes(val)
          )
          this.addFieldsListToBaseObject(
            subMissionBaseObject,
            fieldsListSubMission,
            subMissionDef
          )
          baseObject.subMissions.push(subMissionBaseObject)
        }
      }
      // copy the script inputs that were stored in this.inputs (for form edition)
      // to the proper place for processing this.inputs.scriptConfig.scriptInputs
      if (this.inputs.scriptConfig != null) {
        for (let field in this.inputs.scriptConfig.scriptInputs) {
          this.inputs.scriptConfig.scriptInputs[field].value =
            this.inputs[field]
        }
      }
      return baseObject
    },

    copyFieldsToBaseObject(item, baseObject) {
      this.copyParametricsToGUI(item, baseObject)
      for (let field in this.getPropertiesDescription()) {
        if (item.hasOwnProperty(field)) {
          let fieldType = this.getPropertiesDescription()[field].type
          if (dataDescription[fieldType] != null) {
            // parametric value
            baseObject[field] = dataTools.convertSi2gui(
              this.getFieldType(field),
              item[field]
            )
            this.checkParametricValue(baseObject, field)
          } else {
            baseObject[field] = item[field]
            if (fieldsDescription[fieldType] != null) {
              this.checkParametricReference(baseObject, field)
            }
          }
        }
      }
      if (this.inputs.scriptConfig != null) {
        for (let field in this.inputs.scriptConfig.scriptInputs) {
          // check parametric fields initialized
          this.checkParametricValue(this.inputs, field)
          // copy the script inputs that were stored in this.inputs.scriptConfig.scriptInputs
          // to the proper place for form edition : this.inputs
          this.inputs[field] =
            this.inputs.scriptConfig.scriptInputs[field].value
        }
      }
    },

    getCurrentFormType() {
      return 'ParametricStudyRequest'
    },

    async refreshSpacecrafts() {
      let self = this
      await this.$http
        .get(this.getAPI('parametricspacecraftdefinitions'))
        .then((response) => {
          self.spacecrafts = response.data
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
          self.spacecraftsNotParametricsId = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj.id, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of spacecrafts. ',
            e,
            'AnalyticalMissionErrorDisplay',
            'error'
          )
        })
    },

    async refreshOrbits() {
      let self = this
      await this.$http
        .get(this.getAPI('parametricorbitdefinitions'))
        .then((response) => {
          self.orbits = response.data
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
          self.orbitsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
          self.orbitsNotParametricsId = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj.id, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of orbits. ',
            e,
            'AnalyticalMissionErrorDisplay',
            'error'
          )
        })
    },

    getRefList(param) {
      if (param === 'initialOrbit' || param === 'finalOrbit') {
        return this.orbits
      } else if (param === 'spacecraft') {
        return this.spacecrafts
      }
    }
  }
}
</script>
